import styled from "@emotion/styled";
import { Grid } from "@mui/material";

export const StyledTwoColumnSection = styled(Grid)(({ theme, cssProps }) => {
  const createResponsiveStyles = (styles) => {
    if (!styles || typeof styles !== "object") return {};

    let responsiveCSS = {};

    Object.entries(styles).forEach(([property, value]) => {
      if (typeof value === "object" && value !== null) {
        const breakpoints = ["xs", "sm", "md", "lg", "xl"];

        breakpoints.forEach((breakpoint) => {
          if (value[breakpoint] !== undefined) {
            if (breakpoint === "xs") {
              responsiveCSS[property] = value[breakpoint];
            } else {
              const mediaQuery = theme.breakpoints.up(breakpoint);
              if (!responsiveCSS[mediaQuery]) {
                responsiveCSS[mediaQuery] = {};
              }
              responsiveCSS[mediaQuery][property] = value[breakpoint];
            }
          }
        });
      } else {
        // Regular non-responsive value
        responsiveCSS[property] = value;
      }
    });

    return responsiveCSS;
  };

  const processedCssProps = createResponsiveStyles(cssProps);

  return {
    paddingBlock: "0rem !important",
    margin: "0rem",
    alignItems: "center",
    justifyContent: "center",
    ...processedCssProps,
  };
});
